import React, { useEffect, useState, useRef } from 'react';
import { useGlobalState } from '../contexts/GlobalContext';
import { Link } from 'react-router-dom';
import { isRealtor } from '../utils/userAccess';

function Sidebar() {
  const { state } = useGlobalState();
  const user = state.user;
  const [isInputDropdownOpen, setIsInputDropdownOpen] = useState(false);
  const [isToolsDropdownOpen, setIsToolsDropdownOpen] = useState(false);
  const [isTitanDropdownOpen, setIsTitanDropdownOpen] = useState(false);
  const inputDropdownRef = useRef(null);
  const toolsDropdownRef = useRef(null);
  const titanDropdownRef = useRef(null);

  useEffect(() => {
  const sidebarMenu = document.getElementById('sidebarMenu');

  const handleLinkClick = () => {
    if (sidebarMenu.classList.contains('show')) {
      sidebarMenu.classList.remove('show');
    }
  };

  const links = sidebarMenu?.querySelectorAll('.nav-link') || [];
  links.forEach(link => link.addEventListener('click', handleLinkClick));

  // 🧠 Moved outside the if block so it's always attached
  const handleClickOutside = (event) => {
    if (inputDropdownRef.current && !inputDropdownRef.current.contains(event.target)) {
      setIsInputDropdownOpen(false);
    }
    if (toolsDropdownRef.current && !toolsDropdownRef.current.contains(event.target)) {
      setIsToolsDropdownOpen(false);
    }
    if (titanDropdownRef.current && !titanDropdownRef.current.contains(event.target)) {
      setIsTitanDropdownOpen(false);
    }
  };

  document.addEventListener('mousedown', handleClickOutside);

  return () => {
    links.forEach(link => link.removeEventListener('click', handleLinkClick));
    document.removeEventListener('mousedown', handleClickOutside);
  };
}, []);


  if (!user) return null;

  const isBrokerOrTitan = user.role === 'Broker' || user.role === 'Titan';
  const showRealtorNav = isRealtor(user);
  const teamId = user?.team?.id || null;
  const hasTeam = Boolean(teamId);
  const teamLabel = showRealtorNav ? 'Broker Panel' : 'Team';
  const boardLabel = showRealtorNav ? 'Bulletin Board' : 'Team Board';

  return (
    <nav id="sidebarMenu" className="col-md-3 col-lg-2 d-md-block bg-light sidebar collapse">
      <div className="position-sticky pt-3 sidebar-sticky">
        <ul className="nav flex-column">
          <li className="nav-item">
            <Link className="nav-link" to="/home">Home</Link>
          </li>
          <li className="nav-item">
            <Link className="nav-link" to="/contacts">Contacts</Link>
          </li>
          <li className="nav-item">
            <Link className="nav-link" to="/pipeline">PipeLine</Link>
          </li>
          {showRealtorNav && (
            <>
              <li className="nav-item">
                <Link className="nav-link" to="/allListings">Listings</Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/myListings">My Listings</Link>
              </li>
            </>
          )}
          {hasTeam && (
            <li className="nav-item">
              <Link className="nav-link" to="/bulletinBoard">{boardLabel}</Link>
            </li>
          )}
          <li className="nav-item">
            <Link className="nav-link" to="/tasks">Tasks</Link>
          </li>

          {(hasTeam || isBrokerOrTitan) && (
            <li className="nav-item">
              <Link
                className="nav-link"
                to="/brokerPanel"
                state={{ team: user.team }}
              >
                {teamLabel}
              </Link>
            </li>
          )}

          {user.role === 'Titan' && (
            <>
              {/* Titan Tools Dropdown */}
              <li className="nav-item dropdown" ref={titanDropdownRef}>
                <button
                  className="nav-link dropdown-toggle"
                  onClick={() => setIsTitanDropdownOpen(!isTitanDropdownOpen)}
                >
                  Titan Tools
                </button>
                {isTitanDropdownOpen && (
                  <ul className="dropdown-menu show">
                     <li className="nav-item">
                      <Link className="nav-link" to="/adminAccess">Access Panel</Link>
                    </li>
                    <li>
                      <Link className="dropdown-item" to="/superAdminPanel">
                        Super Admin Panel
                      </Link>
                    </li>
                    <li>
                      <Link className="dropdown-item" to="/titan/feedback">
                        Feedback Review
                      </Link>
                    </li>
                    <li>
                      <Link className="dropdown-item" to="/titan/tests">
                        Test Dashboard
                      </Link>
                    </li>
                  </ul>
                )}
              </li>
            </>
          )}

          {/* Input Dropdown */}
          <li className="nav-item dropdown" ref={inputDropdownRef}>
            <button
              className="nav-link dropdown-toggle"
              onClick={() => setIsInputDropdownOpen(!isInputDropdownOpen)}
            >
              Input
            </button>
            {isInputDropdownOpen && (
              <ul className="dropdown-menu show">
                {showRealtorNav && (
                  <li>
                    <Link className="dropdown-item" to="/form" state={{ role: 're' }}>Listing</Link>
                  </li>
                )}
                <li>
                  <Link className="dropdown-item" to="/form" state={{ role: 'contact' }}>Contact</Link>
                </li>
              </ul>
            )}
          </li>

          {showRealtorNav && (
            <li className="nav-item dropdown" ref={toolsDropdownRef}>
              <button
                className="nav-link dropdown-toggle"
                onClick={() => setIsToolsDropdownOpen(!isToolsDropdownOpen)}
              >
                Tools
              </button>
              {isToolsDropdownOpen && (
                <ul className="dropdown-menu show">
                  <li>
                    <Link className="dropdown-item" to="/csvProcessor">
                      imapp Deduplicator
                    </Link>
                  </li>
                  <li>
                    <Link className="dropdown-item" to="/property-search">
                      Property Lookup
                    </Link>
                  </li>
                </ul>
              )}
            </li>
          )}
        </ul>
      </div>
    </nav>
  );
}

export default Sidebar;
